import { yupResolver } from "@hookform/resolvers/yup";
import { FC, PropsWithChildren } from "react";
import { FormProvider, useForm } from "react-hook-form";

import { IRichLogData } from "@ryde/shared";

import {
  IRichLogsFilter,
  richLogInitialModel,
  richLogValidationSchema,
} from "./rich-logs.models";

interface IRichLogsFormWrapper extends PropsWithChildren {
  logData: IRichLogData | undefined;
  defaultValues?: Partial<IRichLogsFilter>;
}

export const RichLogsFormWrapper: FC<IRichLogsFormWrapper> = ({
  children,
  defaultValues: defaultValuesOverride,
}) => {
  const methods = useForm<Partial<IRichLogsFilter>>({
    defaultValues: { ...richLogInitialModel, ...(defaultValuesOverride ?? {}) },
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(richLogValidationSchema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
